export default {"src":"/_next/static/media/shopping-cart.a60b8a17.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};